import type { ReactNode } from 'react';

export interface ProfileFieldProps {
  label: string;
  value: ReactNode;
}

/** One labelled row inside the profile's field Card — label left, value right, wraps on mobile. */
export function ProfileField({ label, value }: ProfileFieldProps) {
  return (
    <div className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1 py-3 first:pt-0 last:pb-0">
      <span className="text-sm text-muted">{label}</span>
      <span className="text-sm font-medium text-ink">{value}</span>
    </div>
  );
}
